import React from 'react';

const CourseStructure = () => (
  <div className="container mx-auto text-center px-4 sm:px-6 lg:px-8 bg-white py-10 rounded-lg shadow-lg">
    <h2 className="text-3xl sm:text-4xl font-bold text-blue-600 mb-6">Course Structure</h2>
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
      <div className="bg-gray-100 p-6 rounded-lg shadow-md">
        <h3 className="text-2xl font-bold text-blue-600">24</h3>
        <p className="text-lg text-gray-700">Weeks Duration</p>
      </div>
      <div className="bg-gray-100 p-6 rounded-lg shadow-md">
        <h3 className="text-2xl font-bold text-blue-600">96</h3>
        <p className="text-lg text-gray-700">Live Sessions</p>
      </div>
      <div className="bg-gray-100 p-6 rounded-lg shadow-md">
        <h3 className="text-2xl font-bold text-blue-600">5+</h3>
        <p className="text-lg text-gray-700">Projects</p>
      </div>
    </div>
    <h3 className="text-2xl font-bold text-blue-600 mt-8">Prerequisites</h3>
    <div className="mt-6 space-y-4 text-left max-w-3xl mx-auto">
      <h4 className="text-lg font-bold text-gray-700">Required Knowledge</h4>
      <ul className="list-disc list-inside text-gray-700">
        <li>Basic understanding of HTML, CSS, and JavaScript</li>
        <li>Familiarity with programming concepts</li>
        <li>Problem-solving aptitude</li>
      </ul>
      <h4 className="text-lg font-bold text-gray-700 mt-6">Technical Requirements</h4>
      <ul className="list-disc list-inside text-gray-700">
        <li>Laptop with minimum 8GB RAM</li>
        <li>Stable internet connection</li>
        <li>Webcam and microphone for live sessions</li>
      </ul>
    </div>
  </div>
);

export default CourseStructure;
